import { Link } from "react-router-dom";
import type { ServiceBillingSnapshot } from "@/core/billing/service-billing-status";
import { formatMoney } from "@/core/pharmacy/format";
import { routes } from "@/router/all_routes";

interface ServiceBillingBadgeProps {
  snapshot: ServiceBillingSnapshot;
  compact?: boolean;
}

function statusClass(status: ServiceBillingSnapshot["status"]): string {
  if (!status) return "text-bg-secondary";
  if (status === "paid") return "text-bg-success";
  if (status === "cancelled") return "text-bg-dark";
  if (status === "at_cashier" || status === "issued") return "text-bg-warning";
  return "text-bg-light border";
}

export function ServiceBillingBadge({ snapshot, compact = false }: ServiceBillingBadgeProps) {
  if (!snapshot.hasDocument) {
    return <span className="badge text-bg-light border text-muted">Non facturé</span>;
  }

  return (
    <span className="d-inline-flex flex-wrap align-items-center gap-1">
      {snapshot.nightCount != null && snapshot.nightCount > 0 && (
        <span className="badge text-bg-light border text-muted">
          {snapshot.nightCount} nuitée{snapshot.nightCount > 1 ? "s" : ""}
        </span>
      )}
      <span className={`badge ${statusClass(snapshot.status)}`}>{snapshot.statusLabel}</span>
      {!compact && snapshot.amount !== null && (
        <span className="small text-muted">
          {formatMoney(snapshot.totalAmount ?? snapshot.amount)}
        </span>
      )}
      {snapshot.documentId && (
        <Link
          to={routes.billingAccounting}
          className="small text-decoration-none"
          title="Voir en comptabilité"
        >
          Compta →
        </Link>
      )}
    </span>
  );
}
